/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import axios from '@/axios';
import auth from '@/auth/service.js';
import moment from 'moment';

export default {
  SET_TOKEN(state, data) {
    let now = moment();
    let expire = now.add(data.expiresIn, 's');

    // Set local storage
    localStorage.setItem(auth.tokenKey(), data.jwt);
    //localStorage.setItem(auth.tokenExpiryKey(), JSON.stringify(expire));

    // Update state obejct
    state[auth.tokenKey()] = data.jwt;
    //state[auth.tokenExpiryKey()] = expire;

    axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.jwt;
  },
  SET_TOKEN_FROM_LOCALSTORAGE(state, data) {
    // Set local storage
    localStorage.setItem(auth.tokenKey(), data.jwt);
    //    localStorage.setItem(auth.tokenExpiryKey(), JSON.stringify(data.expire));

    // Update state obejct
    state[auth.tokenKey()] = data.jwt;
    //    state[auth.tokenExpiryKey()] = data.expire;

    axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.jwt;
  },
  AUTH_INITIALIZED(state) {
    // Only run this once
    state.isInitialized = true;
  },
  UPDATE_USER_INFO(state, userInfo) {
    // Get Data localStorage

    for (const property of Object.keys(userInfo)) {
      if (userInfo[property] != null) {
        //state[auth.userInfoKey()][property] = userInfo[property];
        Vue.set(state[auth.userInfoKey()], property, userInfo[property]);
      }
    }
    // Store data in localStorage
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  },
  LOGOUT_USER(state, _) {
    // Töm local storage
    localStorage.removeItem(auth.tokenKey());
    localStorage.removeItem(auth.tokenExpiryKey());
    localStorage.removeItem(auth.userInfoKey());

    // Rensa state
    state[auth.tokenKey()] = null;
    state[auth.tokenExpiryKey()] = null;
    state[auth.userInfoKey()] = {};
    state.isInitialized = false;
  }
};
